export function clamp(value, lower, upper) {
    return Math.max(lower, Math.min(upper, value));
}
//# sourceMappingURL=clamp.js.map